export default function getResource(label) {
    const resources = {
        mlActivated: 'ML ACTIVÉ'
    };

    return resources[label];
}
